import { useAuth } from "../context/AuthContext";
import { authRequest } from "../api/api";

export function useApi() {
  const { accessToken, refreshAccessToken } = useAuth();

  return (path, options = {}) =>
    authRequest(path, options, accessToken, refreshAccessToken);
}
